import React from 'react'
import PropTypes from 'prop-types'
import { Container, Callout } from './Callouts.styles'

const Callouts = ({ callouts, parentComponent, textAlign, noMargin }) => {
  const content = callouts.map((callout, index) => (
    <Callout key={callout} data-test={`${parentComponent}-callout-${index}`}>
      {callout}
    </Callout>
  ))

  return (
    <Container data-test={`${parentComponent}-callout-container`} textAlign={textAlign} noMargin={noMargin}>
      {content}
    </Container>
  )
}

Callouts.propTypes = {
  callouts: PropTypes.array.isRequired,
  parentComponent: PropTypes.string
}

export default Callouts
